export enum CouponStatusType {
    Expired = 1,
    CurrentlyValid = 2,
    NotYetValid = 3
}